import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetTranslationStatsResponse } from './get-translation-stats-response';
import { getTranslationStatsResponseSchema } from './get-translation-stats-response';

export async function getTranslationStatsApi(
  collectionId: number,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetTranslationStatsResponse>> {
  return getRequest<IGetTranslationStatsResponse>({
    path: `/sys/pipeline/${collectionId}/translation-stats`,
    schema: getTranslationStatsResponseSchema,
    options,
  });
}
